export default str => {
  if (!str) {
    return str;
  }
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/\'/g, '&apos;')
    .replace(/\"/g, '&quot;');
};
